import { getThemes } from './themes-index';
import * as monaco from 'monaco-editor';

var haveThemesBeenDefined = false;

export function defineCustomThemes() {
	if (haveThemesBeenDefined) return;
	haveThemesBeenDefined = true;

	const themes = getThemes();

	Object.keys(themes).forEach(themeName => {
		const theme = themes[themeName];
		monaco.editor.defineTheme(themeName, theme);
	});
}
